import { type FlexProps } from '@teamsparta/stack-flex';

import * as S from './style';

interface Props extends FlexProps<'span'> {}

export function Skeleton(props: Props) {
  return <S.Wrapper as='span' {...props} />;
}
